module.exports = __webpack_public_path__ + "assets/img/de-e35937f1.png";